export const stateMixin = (model, sortBy) => {
  return {
    model,
    collection: [],
    children: [],
    selected: null,
    loading: false,
    meta: {
      descending: true,
      page: 1,
      rowsPerPage: 20,
      sortBy: sortBy,
      totalItems: 0,
      rowsPerPageItems: [
        20,
        30,
        50,
        100,
        200,
        {
          'text': 'All',
          'value': -1
        }
      ]
    }
  }
}
